import styled from 'styled-components';

type WrapperProps = {
  backgroundUrl?: string;
  onClick?: (event: any) => void;
};

const Wrapper = styled.li<WrapperProps>`
  position: relative;
  width: 32%;
  min-height: 220px;
  height: auto;

  &.has-fulfillment {
    min-height: 268px;

    .video-item,
    .video-item .thumbnail,
    .video-item .thumbnail img {
      min-height: 268px;
    }
  }

  .video-item {
    position: relative;
    width: 100%;
    min-height: 220px;
    height: 100%;
    background: linear-gradient(360deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%), #6B6B6B;
    border-radius: 12px;

    display: flex;
    justify-content: center;
    align-items: center;

    .thumbnail {
      min-height: 220px;
      width: 100%;

      img {
        width: 100%;
        min-height: 220px;
        border-radius: 12px;
        object-fit: cover;
      }
    }

    .no-video {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      pointer-events: none;
    }

    .video-info {
      position: absolute;
      inset: 0;
      pointer-events: none;

      .model {
        position: absolute;
        top: 8px;
        left: 8px;
        max-width: calc(100% - 48px);
      }

      .map {
        position: absolute;
        top: 8px;
        right: 8px;
      }

      .alert-type {
        position: absolute;
        top: 40px;
        left: 8px;
        max-width: calc(100% - 16px);

        &.no-plate {
          top: 8px;
        }

        > div {
          font-size: 12px;
          border-color: rgba(255, 255, 255, 0.24);
          background: rgba(0, 0, 0, 0.55);
          max-width: 100%;
        }

        .label {
          background: rgba(255, 255, 255, 0.18);
          color: white;
        }

        .trigger {
          color: white;
          overflow: hidden;
        }

        .trigger p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .time-sync {
        position: absolute;
        left: 8px;
        top: 8px;
        max-width: calc(100% - 48px);

        &.with-model {
          top: 40px;
        }

        &.with-alert-type {
          top: 72px;
        }
      }

      .video-meta {
        position: absolute;
        bottom: 40px;
        right: 8px;
        left: 8px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 2px;

        &.with-fulfillment {
          bottom: 88px;
        }
      }

      .time {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
        color: white;
        font-size: 13px;
      }

      .video-footer {
        position: absolute;
        bottom: 8px;
        left: 8px;
        right: 8px;
        display: flex;
        flex-direction: column;
        gap: 4px;

        &.with-fulfillment {
          bottom: 8px;
        }
      }

      .video-status {
        font-size: 12px;
        line-height: 1.35;
        font-family: ManropeBold, sans-serif;
        color: ${(props) => props.theme.colors.main_cta};
        white-space: normal;
        word-break: break-word;
      }

      .video-fulfillment-note {
        font-size: 11px;
        line-height: 1.4;
        color: rgba(255, 255, 255, 0.9);
        white-space: normal;
        word-break: break-word;
        overflow-wrap: anywhere;
      }

      .date {
        white-space: nowrap;
        color: white;
        font-size: 13px;
      }
    }

    .map-icon {
      color: white;
    }
  }
`;

export default { Wrapper };
